import React, { useEffect, useState } from "react";
import SidebarRFQ from "../POpage/SidebarRFQ";

const UserProfile = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("userdata");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  if (!user) {
    return <div className="p-4 text-center">Loading profile...</div>;
  }

  return (
    <>
    <div className="row g-0">
      <div className="custom-2-5">
        <SidebarRFQ />
      </div>

      <div className="custom-9-5 dashboardsclooer p-4">
        <div className="profile-card">
          {/* HEADER */}
          <div className="profile-header">
            <div className="avatar">
              {user.name?.charAt(0).toUpperCase()}
            </div>
            <h4>{user.name}</h4>
            <p>{user.email}</p>
          </div>

          {/* BODY */}
          <div className="profile-body">
            <div className="profile-row">
              <span>Email Verified</span>
              <span>
                {user.email_verified_at ? (
                  <span className="status success">Verified</span>
                ) : (
                  <span className="status danger">Not Verified</span>
                )}
              </span>
            </div>

            <div className="profile-row">
              <span>Account Status</span>
              <span>
                {user.deletestatus === "1" ? (
                  <span className="status success">Active</span>
                ) : (
                  <span className="status danger">Inactive</span>
                )}
              </span>
            </div>

            <div className="profile-row">
              <span>Created On</span>
              <span>{new Date(user.created_at).toLocaleDateString()}</span>
            </div>

            <div className="profile-row">
              <span>Last Updated</span>
              <span>{new Date(user.updated_at).toLocaleDateString()}</span>
            </div>
          </div>

          {/* FOOTER */}
          <div className="profile-footer">
            <button
              className="btn-theme"
              onClick={() => {
                localStorage.clear();
                window.location.href = "/";
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
    <style>
      {
        `
        .profile-card {
  max-width: 700px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* HEADER */
.profile-header {
  background: linear-gradient(135deg, #ff650f, #ff8a3d);
  color: #fff;
  padding: 30px;
  text-align: center;
}

.profile-header h4 {
  margin: 10px 0 4px;
  font-weight: 600;
}

.profile-header p {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

/* AVATAR */
.avatar {
  width: 80px;
  height: 80px;
  background: #fff;
  color: #ff650f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  margin: 0 auto;
}

/* BODY */
.profile-body {
  padding: 25px;
}

.profile-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.profile-row:last-child {
  border-bottom: none;
}

/* STATUS */
.status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status.success {
  background: #e6f9f0;
  color: #1b9c6c;
}

.status.danger {
  background: #ffeaea;
  color: #d63031;
}

/* FOOTER */
.profile-footer {
  padding: 20px;
  text-align: right;
}

/* BUTTON */
.btn-theme {
  background: #ff650f;
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.btn-theme:hover {
  background: #e85a0d;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .profile-card {
    margin: 0 auto;
  }

  .profile-row {
    flex-direction: column;
    gap: 6px;
  }

  .profile-footer {
    text-align: center;
  }
}

        `
      }
    </style>
    </>
  );
};

export default UserProfile;
